import React from "react";
import { motion } from "framer-motion";
import { ListTodo, Circle, CheckCheck } from "lucide-react";
import { Progress } from "@/components/ui/progress";
import { useApp } from "@/context/AppContext";

const StatCard = ({ icon: Icon, label, value, accent, testId, delay }) => (
  <motion.div
    data-testid={testId}
    initial={{ opacity: 0, y: 16 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.35, delay }}
    className="relative overflow-hidden rounded-2xl border border-border bg-card p-5 shadow-[0_8px_30px_rgb(0,0,0,0.04)]"
  >
    <div className="flex items-center justify-between">
      <span className="text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground">
        {label}
      </span>
      <span
        className="w-9 h-9 rounded-xl flex items-center justify-center"
        style={{ backgroundColor: `${accent}1a`, color: accent }}
      >
        <Icon className="w-[18px] h-[18px]" />
      </span>
    </div>
    <div className="mt-3 font-heading text-4xl font-bold tabular-nums" style={{ color: accent }}>
      {value}
    </div>
  </motion.div>
);

export const StatsDashboard = ({ total, open, completed }) => {
  const { t } = useApp();
  const percent = total === 0 ? 0 : Math.round((completed / total) * 100);

  return (
    <section className="mb-8" data-testid="dashboard">
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <StatCard
          icon={ListTodo}
          label={t("total")}
          value={total}
          accent="#2563EB"
          testId="stat-total"
          delay={0.05}
        />
        <StatCard
          icon={Circle}
          label={t("open")}
          value={open}
          accent="#F59E0B"
          testId="stat-open"
          delay={0.1}
        />
        <StatCard
          icon={CheckCheck}
          label={t("completed")}
          value={completed}
          accent="#10B981"
          testId="stat-completed"
          delay={0.15}
        />
      </div>

      <div className="mt-4 rounded-2xl border border-border bg-card p-5 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
        <div className="flex items-center justify-between mb-2">
          <span className="text-xs font-bold uppercase tracking-[0.15em] text-muted-foreground">
            {t("progress")}
          </span>
          <span className="font-heading font-bold text-primary tabular-nums" data-testid="progress-percent">
            {percent}%
          </span>
        </div>
        <Progress value={percent} className="h-2.5" data-testid="progress-bar" />
      </div>
    </section>
  );
};
